import React from "react";

const map = {
  requested: "bg-slate-100 text-slate-700",
  quoted: "bg-amber-100 text-amber-800",
  accepted: "bg-blue-100 text-blue-800",
  paid: "bg-emerald-100 text-emerald-800",
  in_progress: "bg-indigo-100 text-indigo-800",
  completed: "bg-emerald-500 text-white",
  declined: "bg-rose-100 text-rose-700",
  cancelled: "bg-rose-100 text-rose-700",
};
const label = {
  requested: "Requested",
  quoted: "Quote sent",
  accepted: "Accepted",
  paid: "Paid",
  in_progress: "In progress",
  completed: "Completed",
  declined: "Declined",
  cancelled: "Cancelled",
};

export default function StatusBadge({ status }) {
  return (
    <span data-testid={`status-badge-${status}`} className={`badge-status ${map[status] || "bg-slate-100 text-slate-700"}`}>
      {label[status] || status}
    </span>
  );
}
